import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Grid, Stack, Typography, useTheme } from '@mui/material';
import { SelectedAssessmentIdQuery } from '../../clinicApp/pages/assessment/assessment.queryParams.interface';
import { useQuerySync } from '../../state/queryParams/useQuerySync';
import { di } from '../../state/inversify.config';
import { SummaryClinicalNotesPdf } from './summaryClinicalNotesPdf';
import { SummaryTable } from '../../clinicApp/pages/assessment/summary/summaryTable.smart';
import { AssessmentSummaryQueryService } from './assessmentSummary.queryParam.service';
import { AssessmentSummaryDomain } from './assessmentSummary.domain';
import { SummaryCard } from '../../clinicApp/pages/assessment/summary/summaryCard.smart';
import { Spinner } from '../../components/spinner/spinner';
import { Banner } from '../../components/banner/banner';

export const clinicAssessmentType = 'co.hitiq.portal.md.clearance_screen';

export function AssessmentSummaryPage() {
  const { t } = useTranslation();
  const theme = useTheme();
  const assessmentSummaryQueryService = di.get<AssessmentSummaryQueryService>(
    AssessmentSummaryQueryService,
  );
  useQuerySync<SelectedAssessmentIdQuery>(assessmentSummaryQueryService);

  const assessmentSummaryDomain = di.get<AssessmentSummaryDomain>(
    AssessmentSummaryDomain,
  );
  const assessment = assessmentSummaryDomain.useAssessmentSelector();
  const clinicAssessment =
    assessment !== undefined &&
    assessment.assessment.assessmentType === clinicAssessmentType;

  return (
    <Container>
      {assessment !== undefined ? (
        <>
          {assessment.assessment.assessment ? (
            <Grid>
              <Typography variant="h6">
                {t('assessment.ASSESSMENT_SUMMARY')}
              </Typography>
              <SummaryCard assessment={assessment} />
              {clinicAssessment && (
                <SummaryTable modules={assessment.assessment.assessment} />
              )}
              <Grid sx={{ my: 4 }}>
                {assessment.assessment.clearedToPlay ? (
                  <Typography
                    variant="h6"
                    sx={{ color: theme.palette.success.main }}
                    fontWeight="bold"
                  >
                    {t('assessment.PATIENT_CLEAR_TO_PLAY')}
                  </Typography>
                ) : (
                  <Typography
                    variant="h6"
                    sx={{ color: theme.palette.error.main }}
                    fontWeight="bold"
                  >
                    {t('assessment.PATIENT_NOT_CLEAR_TO_PLAY')}
                  </Typography>
                )}
              </Grid>

              {clinicAssessment && (
                <SummaryClinicalNotesPdf assessmentId={assessment.id} />
              )}
            </Grid>
          ) : (
            <Spinner open />
          )}
        </>
      ) : (
        <Banner
          severity="warning"
          elevation={2}
          title={t('assessment.ASSESSMENT_SUMMARY_NOT_AVAILABLE')}
        />
      )}
    </Container>
  );
}
